<template>
  <div id="loading"
       class="min-h-screen w-full flex items-center justify-center p-4 text-white"
       style="background: linear-gradient(to bottom, #2972db 0%, #163D75 100%);">

    <div class="w-full max-w-sm flex flex-col items-center gap-6">
      <!-- Logo centré pour cohérence avec InitLoading -->
      <div class="flex justify-center">
        <span class="logo hidden"></span>
        <img :src="logoUrl"
             alt="logo fi360"
             class="h-16 w-auto select-none" />
      </div>

      <!-- Radial progress dans une carte légère -->
      <div class=" flex flex-col items-center">
        <radial-progress-bar
          :diameter="220"
          :animate-speed="80"
          :completed-steps="completedSteps"
          :total-steps="totalSteps"
          :start-color="startColor"
          :stop-color="stopColor"
          inner-stroke-color="#ffffff"
        >
          <!-- Texte principal -->
          <p class="info-dl text-center text-sm mt-4 mb-2">
            {{ txtSync }}
          </p>

          <!-- Petits points de chargement -->
          <div id="loader-2" class="mt-4 flex items-center justify-center gap-2 loader-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>

          <!-- Sous-texte -->
          <div id="textInfo" class="mt-3 text-xs text-white/80 text-center">
            Merci de patienter
          </div>
        </radial-progress-bar>
      </div>
    </div>
  </div>
</template>

<script>

    import RadialProgressBar from 'vue-radial-progress'
    import Synchro from '../../js/core/Synchro'
    import Api from '../../js/core/Api'

    export default {

        data() {
            return {
                txtSync: 'Synchonisation de vos données utilisateur',
                completedSteps: 0,
                totalSteps: 18,
                stopColor: "#09295A",
                startColor: "#09295A",
                count: 0,
                logoUrl: require('@/img/logo-fi360-nomadia-blanc.svg')
            }
        },

        methods: {

            async launchSynchro(){

                try {
                    await Synchro.syncUser();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des détenteurs";
                    await Synchro.syncDetenteurs();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des installations";
                    await Synchro.syncInstallations();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des informations installations";
                    await Synchro.syncInformationInstallations();
                    this.completedSteps++;


                    this.txtSync = "Synchronisation des bouteilles";
                    await Synchro.syncBouteilles();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des outils";
                    await Synchro.syncOutils();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des contrats d'assemblage";
                    await Synchro.syncContrats();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des fiches fibsdd";
                    await Synchro.syncFibsdds();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des operations bouteille";
                    await Synchro.syncOperationsBouteille();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des scans bouteille";
                    await Synchro.syncScansBouteille();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des autres scans";
                    await Synchro.syncScansInstallations();
                    this.completedSteps++;

                    this.txtSync = "Synchronisation des fuites";
                    await Synchro.syncFuites();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches pièces";
                    await Synchro.syncPieces();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches photos";
                    await Synchro.syncPhotos();
                    this.completedSteps++;

                    this.txtSync = "Cloture des fiches fibsdd";
                    await Synchro.cloturesFinalesFibsdd();
                    this.completedSteps++;

                    this.txtSync = "Cloture des bouteilles";
                    await Synchro.cloturesFinalesBouteille();
                    this.completedSteps++;

                    this.txtSync = "Envoi des mails Fibsdd";
                    await Synchro.launchMailsFibsdd();
                    this.completedSteps++;

                    this.txtSync = "Envoi des mails restitution bouteille";
                    await Synchro.launchRestitsBouteille();
                    this.completedSteps++;
                    this.txtSync = "Synchronisation terminée";

                    document.getElementById('loader-2').classList.add('disabled');

                    localforage
                        .setItem('offlineActions', JSON.stringify([]))
                        .then(() => this.$router.push({name: 'init'}))
                        .catch(() => this.$router.push({name: 'init'}))



                }
                catch (e) {
                    let api = await Api.init();
                    //let router = this.$router;

                    api
                        .post('/mail/report', {text: JSON.stringify(e)})
                        .then(() => {
                            /*
                            if(e === ""){
                                localforage
                                    .setItem('offlineActions', JSON.stringify([]))
                                    .then(() => router.push({name: 'init'}))
                                    .catch(() => router.push({name: 'init'}))
                            }*/
                            document.getElementById('textInfo').innerText = "Merci de relancer la synchro"
                            document.getElementById('loader-2').classList.add('disabled');
                            //router.push({name : 'init'});
                            return false
                        })
                        .catch(() => {
                            document.getElementById('textInfo').innerText = "Merci de relancer la synchro"
                            document.getElementById('loader-2').classList.add('disabled');
                            //router.push( { name : 'init' });
                        })


                }

            }

        },

        mounted() {

            this.launchSynchro()

        },

        components: {
            RadialProgressBar
        }

    }

</script>

<style scoped>
/* Points de chargement sous le cercle (on garde l’animation existante) */
.loader-dots span {
  display: inline-block;
  width: 15px;
  height: 15px;
  border-radius: 9999px;
  background-color: #C2DDFF;
}

.loader-dots span:nth-child(1) {
  animation: bounce 1s ease-in-out infinite;
}
.loader-dots span:nth-child(2) {
  animation: bounce 1s ease-in-out 0.33s infinite;
}
.loader-dots span:nth-child(3) {
  animation: bounce 1s ease-in-out 0.66s infinite;
}

#loader-2.disabled span {
  animation: none;
}

@keyframes bounce {
  0%, 75%, 100% {
    transform: translateY(0);
  }
  25% {
    transform: translateY(-20px);
  }
}
</style>



// WEBPACK FOOTER //
// Synchro.vue?2c580cd1